module.exports = __webpack_public_path__ + "f5379687bccdc193e4b2670b0b6041b5.png";